module.exports = {
	// Stage left for desktop when closed (showing icons only).
	widthStageLeftCollapsed: '4rem',
	// Stage left for desktop when open.
	widthStageLeftExpanded: '15rem',
	// Header for desktop.
	heightHeader: '3.125rem',
	// Medium tap target size
	squareIconMedium: '2rem',
	fontSizeSmall: '0.75rem',
	fontSizeMedium: '0.8125rem',
	fontSizeMediumA: '0.875rem',
	fontSizeLarge: '1rem',
	fontSizeXLarge: '1.25rem',
	fontSizeXxLarge: '1.75rem',
	// Unitless line-heights for reusability
	lineHeightText: '1.5',
};
